export enum DrView {
  Analytics = 'analytics',
  Chat = 'chat',
  MutualActionPlan = 'actionPlan',
  Settings = 'settings',
  Presentation = 'presentation',
  Files = 'files',
}
